import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { ref, onValue } from "firebase/database";

export default function AdminAuth() {
  const [adminData, setAdminData] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const ADMIN_EMAIL = "admin@tasktracker.com";

  // Fetch the "key" from DB (username: admin / password: password)
  useEffect(() => {
    const adminRef = ref(db, "admin_settings/credentials");
    const unsubscribe = onValue(adminRef, (snapshot) => {
      if (snapshot.exists()) {
        setAdminData(snapshot.val());
      }
    });
    return () => unsubscribe();
  }, []);

  const handleAdminAuth = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      // 1. Check against Database
      if (
        adminData &&
        username === adminData.username &&
        password === adminData.password
      ) {
        // 2. Sign in to Firebase Auth to trigger the App.jsx redirect
        // User admin@tasktracker.com must exist in Firebase Auth with password 'password.admin'
        await signInWithEmailAndPassword(auth, ADMIN_EMAIL, "password.admin");

        setSuccess("Access Granted! Opening Dashboard...");
      } else {
        throw new Error("Invalid Username or Password");
      }
    } catch (err) {
      if (
        err.code === "auth/invalid-credential" ||
        err.code === "auth/user-not-found"
      ) {
        setError(
          "Auth Error: Create 'admin@tasktracker.com' in Firebase Auth Tab."
        );
      } else {
        setError(err.message);
      }
    }
  };

  return (
    <div className="space-y-6 p-4">
      <div className="text-center">
        <h2 className="text-2xl font-black dark:text-white uppercase tracking-tighter">
          Admin Portal
        </h2>
        <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest mt-1">
          Authorized Access Only
        </p>
      </div>

      <form onSubmit={handleAdminAuth} className="space-y-4">
        <input
          type="text"
          placeholder="Admin Username"
          required
          className="w-full p-4 rounded-2xl bg-slate-50 dark:bg-slate-800 dark:text-white border-2 border-transparent focus:border-indigo-500 font-bold outline-none"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          required
          className="w-full p-4 rounded-2xl bg-slate-50 dark:bg-slate-800 dark:text-white border-2 border-transparent focus:border-indigo-500 font-bold outline-none"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && (
          <p className="text-red-500 text-[10px] font-black uppercase px-2">
            {error}
          </p>
        )}
        {success && (
          <p className="text-emerald-500 text-[10px] font-black uppercase px-2">
            {success}
          </p>
        )}

        <button className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest shadow-xl active:scale-95 transition-all">
          Login to Dashboard
        </button>
      </form>
    </div>
  );
}
